export default class {
    constructor ($translate) {
        this.$translate = $translate;
    }

    getIntroduction (companyI18n) {
        if (companyI18n && companyI18n.evaluationGroupReportIntroduction) {
            return companyI18n.evaluationGroupReportIntroduction;
        }
        return this.$translate.instant('report.alias.group.introduction_text');
    }

    getResults (companyI18n) {
        if (companyI18n && companyI18n.evaluationGroupReportResults) {
            return companyI18n.evaluationGroupReportResults;
        }
        return this.$translate.instant('report.alias.group.results_text');
    }

    getStatistics (companyI18n) {
        if (companyI18n && companyI18n.evaluationGroupReportStatistics) {
            return companyI18n.evaluationGroupReportStatistics;
        }
        return this.$translate.instant('report.alias.group.statistics_text');
    }

    getSummary (companyI18n) {
        if (companyI18n && companyI18n.evaluationGroupReportSummary) {
            return companyI18n.evaluationGroupReportSummary;
        }
        return this.$translate.instant('report.alias.group.summary_text');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluation/report/group/index.js